import { render, staticRenderFns } from "./NotificationsTalentDeclinedListItem.vue?vue&type=template&id=2ce6bd4e&scoped=true&"
import script from "./NotificationsTalentDeclinedListItem.vue?vue&type=script&lang=ts&"
export * from "./NotificationsTalentDeclinedListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsTalentDeclinedListItem.vue?vue&type=style&index=0&id=2ce6bd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6bd4e",
  null
  
)

/* custom blocks */
import block0 from "./NotificationsTalentDeclinedListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports